import { BaseService } from "./../../base";
export class TomamuestraService extends BaseService {
  static async getSamples(rut) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}patient/get_result_patient/${rut}/${window.localStorage.getItem("tokenSamples")}`, null);
  }
}
